/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import { FormGroup, Input, Label } from 'reactstrap';
import { CompanyImportRow } from '@g17eco/types/onboarding';

interface ConflictCompaniesProps {
  rows: CompanyImportRow[];
}

export const ConflictCompanies = ({ rows }: ConflictCompaniesProps) => {
  if (rows.length === 0) {
    return null;
  }

  return (
    <div className='mt-4 text-md'>
      <div className='strong'>Conflicts</div>
      <div className='mt-2 mb-3'>There are conflicts with the following companies, please select an action for each:</div>

      {rows.map((row) => {
        const { id, data } = row;
        const importMethodKey = `${id}-${data.initiativeId}-import-method`;
        return (
          <div className='d-flex-col px-1' key={importMethodKey}>
            <div className='text-medium'>{data.companyName}</div>
            <div className='d-flex mt-2'>
              <FormGroup >
                <Label className='text-sm m-0'>
                  <Input type='radio' name={importMethodKey} defaultChecked={true} onChange={() => {}} />
                  <span className='ml-2'>Create new company</span>
                </Label>
              </FormGroup>
              <FormGroup className='ml-4'>
                <Label className='text-sm m-0'>
                  <Input type='radio' name={importMethodKey} onChange={() => {}} />
                  <span className='ml-2'>Add to portfolio (Datashare off)</span>
                </Label>
              </FormGroup>
            </div>
          </div>
        );
      })}
    </div>
  );
};
